import {
    LIST_DEPENDENCY_TYPES,
    LIST_DEPENDENCY_TYPES_SUCCESS,
    LIST_DEPENDENCY_TYPES_ERROR,
    ADD_DEPENDENCY_TYPES,
    SAVE_DEPENDENCY_TYPES,
    SAVE_DEPENDENCY_TYPES_SUCCESS,
    SAVE_DEPENDENCY_TYPES_ERROR,
    EDIT_DEPENDENCY_TYPES,
    UPDATE_DEPENDENCY_TYPES,
    UPDATE_DEPENDENCY_TYPES_SUCCESS,
    UPDATE_DEPENDENCY_TYPES_ERROR,
    DELETE_DEPENDENCY_TYPES,
    DELETE_DEPENDENCY_TYPES_SUCCESS,
    DELETE_DEPENDENCY_TYPES_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    dependencyTypes: null,
    error: null,
    loading: false,
    dependencyTypeSelected: null,
    isEdit: false,
    loadingSave: false,
    errorSave: null
}

export default function(state = initialState, action) {
    switch(action.type){
        case LIST_DEPENDENCY_TYPES:
            return {
                ...state,
                loading: true
            }
        case LIST_DEPENDENCY_TYPES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_DEPENDENCY_TYPES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                dependencyTypes: action.payload
            }
        case SAVE_DEPENDENCY_TYPES:
        case DELETE_DEPENDENCY_TYPES:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_DEPENDENCY_TYPES:
            return {
                ...state,
                loadingSave: true
            }
        case SAVE_DEPENDENCY_TYPES_ERROR:
        case UPDATE_DEPENDENCY_TYPES_ERROR:
        case DELETE_DEPENDENCY_TYPES_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_DEPENDENCY_TYPES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                dependencyTypes: [...state.dependencyTypes, action.payload]
            }
        case ADD_DEPENDENCY_TYPES:
            return {
                ...state,
                dependencyTypeSelected: null,
                isEdit: false
            }
        case EDIT_DEPENDENCY_TYPES:
            return {
                ...state,
                dependencyTypeSelected: action.payload,
                isEdit: true
            }
        case UPDATE_DEPENDENCY_TYPES_SUCCESS:
        case DELETE_DEPENDENCY_TYPES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                dependencyTypes: state.dependencyTypes.map(dependencyType => 
                    dependencyType.id === action.payload.id ? dependencyType = action.payload : dependencyType
                ),
                dependencyTypeSelected: null
            }
        // case DELETE_DEPENDENCY_TYPES_SUCCESS:
        //     return {
        //         ...state,
        //         loadingSave: false,
        //         errorSave: null,
        //         dependencyTypes: state.dependencyTypes.filter( dependencyType => dependencyType.id !== action.payload)
        //     }
        default:
            return state;
    }
}